import { render, staticRenderFns } from "./BookIcon.vue?vue&type=template&id=c3c8c042"
import script from "./BookIcon.vue?vue&type=script&lang=ts"
export * from "./BookIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c8c042')) {
      api.createRecord('c3c8c042', component.options)
    } else {
      api.reload('c3c8c042', component.options)
    }
    module.hot.accept("./BookIcon.vue?vue&type=template&id=c3c8c042", function () {
      api.rerender('c3c8c042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/BookIcon.vue"
export default component.exports